export enum AutoSaveContext {
  LOCAL = 0,
  EXTERNAL = 1
}
